document.addEventListener("DOMContentLoaded", () => {
    const maps = document.querySelectorAll(".communities-map-block");

    maps.forEach((block) => {
        const communities = JSON.parse(block.dataset.communities || "[]");
        const mapContainer = block.querySelector(".map-container");
        const iconUrl = block.dataset.iconUrl;

        const mapStyles = [
            {
                featureType: "all",
                elementType: "geometry",
                stylers: [{ color: "#f2f2f2"}]
            },
            {
                featureType: "administrative",
                elementType: "geometry",
                stylers: [{ visibility: "on" }, { color: "#f2f2f2" }]
            },
            {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [{ color: "#f4ebc0" }]
            },
            {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [{ color: "#f4ebc0" }]
            },
            {
                featureType: "water",
                elementType: "geometry.fill",
                stylers: [{ color: "#c0e2ff" }]
            },
            {
                featureType: "poi",
                elementType: "geometry.fill",
                stylers: [{ color: "#c0e2ff" }]
            },
            {
                featureType: "all",
                elementType: "labels.text.fill",
                stylers: [{ color: "#272e46" }]
            },
            {
                featureType: "all",
                elementType: "labels.text.stroke",
                stylers: [{ color: "#ffffff" }]
            },
            {
                featureType: "poi",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "transit",
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }],
            },
        ];

        const defaultCenter = communities.length
            ? { lat: parseFloat(communities[0].lat), lng: parseFloat(communities[0].lng) }
            : { lat: 39.8283, lng:  -98.5795 };

        let initialZoom = communities.length > 0 ? 12 : 3;
            

        const map = new google.maps.Map(mapContainer, {
            center: defaultCenter,
            zoom: initialZoom,
            zoomControl: true,
            styles: mapStyles
        });

        if (communities.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            const infoWindow = new google.maps.InfoWindow();

            communities.forEach((community) => {
                const marker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(community.lat),
                        lng: parseFloat(community.lng),
                    },
                    map,
                    title: community.title,
                    icon: {
                        url: iconUrl,
                        scaledSize: new google.maps.Size(50, 75),
                        anchor: new google.maps.Point(15, 15),
                    },
                });

                const content = `
                    <div style="padding: 10px; min-width: 200px;">
                        <h3 style="margin: 0 0 8px 0; color: #000000;">${community.title}</h3>
                        ${community.description ? `<p style="margin: 0 0 8px 0; color: #666;">${community.description}</p>` : ""}
                        ${community.url ? `<a href="${community.url}" target="_blank" style="color: #236d9f; text-decoration: none;">View Details →</a>` : ""}
                    </div>
                `;

                marker.addListener("click", () => {
                    infoWindow.setContent(content);
                    infoWindow.open(map, marker);
                });

                bounds.extend(marker.getPosition());
            });

            if (communities.length > 1) {
                map.fitBounds(bounds);
            }
        }
    });
});
